import { useState } from 'react';
import { analyzeTone } from '../services/api';

export interface ToneProfile {
  tone: string;
  structure: string;
  quirks: string[];
  vocab: string[];
}

export const useToneAnalysis = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const analyzeSamples = async (samples: string[]): Promise<ToneProfile> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const { data } = await analyzeTone(samples);
      return data;
    } catch (err) {
      // If err is a string, it's our custom network error message
      const errorMessage = typeof err === 'string' 
        ? err 
        : (err instanceof Error ? err.message : 'Failed to analyze tone');
      
      setError(errorMessage);
      throw errorMessage;
    } finally {
      setIsLoading(false);
    }
  };

  return { analyzeSamples, isLoading, error };
};
